import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { zxRoles } from '@/mocks/zhongxian-commerce';

export default function SystemRoles() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          title="系统角色与职责"
          subtitle="从政府监管、市场运营、农户生产，到商户经营、仓储门店、银行支付、合作伙伴、返乡青年与消费者，九类角色在同一平台上各司其职、协同运转。"
        />

        <div className="mt-12 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {zxRoles.map((role, idx) => (
            <Reveal key={role.name} delay={Math.min(idx * 60, 420)}>
              <div className="h-full flex items-start gap-4 p-6 rounded-lg bg-background-50 border border-background-200 transition-colors hover:border-primary-300">
                <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${role.icon} text-xl`}></i>
                </span>
                <div className="min-w-0">
                  <span className="text-[11px] font-semibold tracking-widest text-foreground-400">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <h3 className="font-heading font-bold text-base text-foreground-950 leading-snug">{role.name}</h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{role.duty}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}